import React from 'react'
import { i18n } from '@fs/zion-locale'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'
import { useUser } from '@fs/zion-user'
import localeMapping from '../usabilla'
import rtTree from '../images/rt-tree.png'
import useIsMobile from '../hooks/useIsMobile'

const wrapperCss = css`
  transform: rotate(-90deg);
  transform-origin: left top;
  position: fixed;
  bottom: -12px;
  left: 0;
  height: 36px;
`
const buttonCss = css`
  color: ${colors.billboard.red30};
  border: none;
  padding: 10px 16px 10px 40px;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 12px;
  line-height: 12px;
  font-weight: bold;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: #fff url(${rtTree}) no-repeat 11px 5px;
`

export default function Feedback() {
  const { signedIn, displayName, cisId } = useUser()

  const openForm = () => {
    if (signedIn) {
      window.usabilla_live('data', {
        custom: {
          cisId,
          displayName,
        },
      })
    }
    window.usabilla_live('setForm', localeMapping[i18n.language] || '')
    window.usabilla_live('click')
  }
  const [t] = useTranslation()
  const isMobile = useIsMobile()

  if (isMobile) return null

  return (
    <div css={wrapperCss}>
      <button css={buttonCss} type="button" onClick={openForm}>
        {t('footer.feedback', 'Feedback')}
      </button>
    </div>
  )
}
